import { render, staticRenderFns } from "./use-plugin-dropdown.vue?vue&type=template&id=0b1aefdb&scoped=true&"
import script from "./use-plugin-dropdown.vue?vue&type=script&lang=js&"
export * from "./use-plugin-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./use-plugin-dropdown.vue?vue&type=style&index=0&id=0b1aefdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1aefdb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
